import { getApiVersion, http } from '@vt/apis/lib-ex'

// 创建报告任务
export const reportTaskSyhjws = (tbId, data) => {
  return http()
    .post(
      `${getApiVersion()}/apps/shengyang_sxh/exportAreaFile?tbId=${tbId}`,
      data,
      {
        throwHttpErrors: false,
      }
    )
    .json()
}
